import { Skeleton } from "@lendcord/concord";

// Mirrors ReportCard's shape (icon circle, heading, description line, button)
// — see docs/design-system.md's "Loading states" section.
export function ReportCardSkeleton() {
  return (
    <div className="mx-auto max-w-md rounded-md border border-border bg-surface-raised p-8 text-center shadow-sm">
      <Skeleton variant="circle" className="mx-auto h-16 w-16" />
      <Skeleton variant="text" className="mx-auto mt-4 h-7 w-40" />
      <Skeleton variant="text" className="mx-auto mt-2 h-5 w-56" />
      <Skeleton variant="rect" className="mt-8 h-10 w-full" />
    </div>
  );
}
